export enum supportedLanguages {
  en = 'en',
  it = 'it',
  de = 'de',
  fr = 'fr',
  es = 'es',
  kr = 'kr',
  jp = 'jp',
  ch = 'ch',
  chs = 'chs',
}
